// components/feed/SpecializedFeedSection.js
import React from 'react';
import FeedSection from './FeedSection';

/**
 * Component factory for different feed types
 * 
 * All feed types now route through FeedSection which handles
 * actual API fetching and rendering via FeedItem.
 * 
 * Previously, rss/xml/department cases were placeholder stubs
 * that only rendered static text. Now they all use FeedSection
 * so data loads properly on desktop.
 */

// RSS Feed Component - uses FeedSection for real data fetching
export const RSSFeedSection = ({ title, apiEndpoint, feedName, branch, topic, buttonName, maxItems }) => {
  return (
    <FeedSection
      title={title}
      apiEndpoint={apiEndpoint}
      feedName={feedName}
      branch={branch}
      topic={topic}
      buttonName={buttonName}
      maxItems={maxItems}
    />
  );
};

// XML Feed Component - uses FeedSection for real data fetching
export const XMLFeedSection = ({ title, apiEndpoint, feedName, branch, topic, buttonName, maxItems }) => {
  return (
    <FeedSection
      title={title}
      apiEndpoint={apiEndpoint}
      feedName={feedName}
      branch={branch}
      topic={topic}
      buttonName={buttonName}
      maxItems={maxItems}
    />
  );
};

// Department API Feed Component - uses FeedSection for real data fetching
export const DepartmentFeedSection = ({ title, apiEndpoint, feedName, branch, topic, buttonName, maxItems }) => {
  return (
    <FeedSection
      title={title}
      apiEndpoint={apiEndpoint}
      feedName={feedName}
      branch={branch}
      topic={topic}
      buttonName={buttonName}
      maxItems={maxItems}
    />
  );
};

// Main component that routes to appropriate feed type
const SpecializedFeedSection = ({ 
  feedType, 
  title, 
  apiEndpoint, 
  feedName, 
  branch, 
  topic, 
  buttonName, 
  maxItems 
}) => {
  const commonProps = {
    title,
    apiEndpoint,
    feedName,
    branch,
    topic,
    buttonName,
    maxItems
  };

  switch (feedType) {
    case 'rss':
      return <RSSFeedSection {...commonProps} />;
    case 'xml':
      return <XMLFeedSection {...commonProps} />;
    case 'department':
      return <DepartmentFeedSection {...commonProps} />;
    default:
      return (
        <FeedSection
          title={title}
          apiEndpoint={apiEndpoint}
          feedName={feedName}
          branch={branch}
          topic={topic}
          buttonName={buttonName}
          maxItems={maxItems}
        />
      );
  }
};

export default SpecializedFeedSection;